import { AIAppsManager } from "@/components/Settings/AIAppsManager";

export function SettingsAIApps() {
  return (
    <div className="space-y-6 p-6">
      <div>
        <h1 className="text-3xl font-bold">AI Apps</h1>
        <p className="mt-2 text-muted-foreground">
          Create, update, and remove AI application configurations.
        </p>
      </div>
      <AIAppsManager />
    </div>
  );
}

